import { render, staticRenderFns } from "./BookingAssistant12.vue?vue&type=template&id=fb1e2c3c&scoped=true&lang=pug&"
import script from "./BookingAssistant12.vue?vue&type=script&lang=ts&"
export * from "./BookingAssistant12.vue?vue&type=script&lang=ts&"
import style0 from "./BookingAssistant12.vue?vue&type=style&index=0&id=fb1e2c3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1e2c3c",
  null
  
)

export default component.exports